import { Dispatch, SetStateAction, useState } from 'react';
import { Employee } from '../utils/AccountsAPI';
import { cloneDeep } from 'lodash';

export const useUsers = (initialVal) => {
  const [users, setUsers] = useState<Employee[]>(initialVal ?? []);

  function updateUser(user: Employee, updateFunc?: Function, addNew = false) {
    setUsers((u) => {
      var updatedUsers = cloneDeep(u);
      var index = u.findIndex((us) => us.id === user.id);
      if (index > -1) {
        if (updateFunc) {
          updateFunc(updatedUsers[index], updatedUsers, index);
        } else updatedUsers.splice(index, 1, user);
      } else if (addNew) {
        updatedUsers.push(user);
        if (updateFunc) {
          updateFunc(updatedUsers[updatedUsers.length - 1], updatedUsers, updatedUsers.length - 1);
        }
        updatedUsers = updatedUsers.sort((a, b) => (a.userName < b.userName ? -1 : 1));
      }
      return updatedUsers;
    });
  }

  return [users, setUsers, updateUser] as [Employee[], Dispatch<SetStateAction<Employee[]>>, (user: Employee, updateFunc?: Function | undefined, addNew?: boolean) => void];
};
